<template>
  <div class="w-100">
    <div v-if="is_load" class="w-100 text-center py-4">
      <loader></loader>
    </div>
    <template v-else>
      <div class="w-100 border-form radius-6 mb-4" v-for="(form,form_i) in forms" :key="form_i">
        <div class="p-3 mb-3 border-b-semi-grey bg-light-page radius-t-6">
          <p class="mb-0 text-24 font-lato text-dark d-inline-block align-middle mr-3">{{ form_i+1 }}</p>
          <div class="mb-0 d-inline-block align-middle">
            <p class="mb-0 body-1-4">{{ form.variant_name }}</p>
            <p class="mb-0 body-2-2-1">{{ form.product_name }}</p>
          </div>
        </div>
        <div class="px-3">
          <div class="row">
            <div class="col-sm-6 col-12 mb-3" v-for="(addt_form,addt_form_i) in form.additional_information">
              <div class="w-100">
                <label class="body-3 mb-1 d-block">{{addt_form.label}} <span v-if="addt_form.is_required" class="font-weight-bold text-danger">*</span></label>
                <input 
                  type="text" 
                  class="p-3 body-2-1 w-100 border-form radius-6" 
                  :class="{'border-danger': addt_form.error}"
                  v-model="forms[form_i].additional_information[addt_form_i].value" >
                <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="addt_form.error">This column is required</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        is_load: true,
        forms: []
      }
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      loadFirstData(){
        this.is_load = true
        this.forms = this.$deepCopy(this.data)
        setTimeout(() => {
          this.is_load = false
        }, 100);
      },
      validateForm(){
        return new Promise((success)=>{
          this.forms = this.forms.map(x=>{
            x.additional_information = x.additional_information.map(y=>{
              y.error = ''
              return y
            })
            return x
          })

          let total_error = 0
          this.forms.forEach((form,form_i)=>{
            form.additional_information.forEach((addt_form,addt_form_i)=>{
              if(addt_form.is_required && addt_form.value == ''){
                this.forms[form_i].additional_information[addt_form_i].error = true
                total_error++
              }

              if(addt_form_i+1 == form.additional_information.length && form_i+1 == this.forms.length){
                if(total_error > 0){
                  fail()
                }else{
                  success(this.forms)
                }
              }
            })
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ticket/ProductAdditionalForm.vue